module.exports = __webpack_public_path__ + "img/no_worries_01.09430f24.png";